import { Container, Row, Col } from "react-bootstrap";
import ContactFormCard from "../../../../components/forms/contact-form-card";

import BrandsCarousel from "../../../../components/carousels/brands-carousel";
import TestimonialCarousel from "../../../../components/carousels/testimonial-carousel";
import ContactForm from "../../../../components/forms/contact-form";
import TestimonialVideoPlayer from "../../../../components/videos/testimonial-video";
import AcubeIntroVideo from "../../../../components/videos/acube-video";
import { AusFlag, IndianFlag, USAFlag } from "../../../../assets/common/common";
import SentryVideoTestimonial from "../../../../components/videos/sentry-video";

const ContactUs = () => {
  return (
    <>
      <section className="contact-us-section">
        <Container fluid>
          <Row>
            <Col xs="12">
              <h2 className="text-primary ft-wt-600 mb-0">Contact Us</h2>
            </Col>
            <Col xs="12" md="6" xl="7" className="bg-img">
              <Row>
                <Col xs="12">
                  <Row className="gap-3 gap-lg-0 mt-4 mt-lg-5 mb-120">
                    <Col xs="12" xl="6">
                      <div className="address-item">
                        <div className="flag-circle">
                          <img src={USAFlag} alt="USA Flag" loading="lazy" />
                        </div>
                        <div className="address-info">
                          <h1 className="ft-wt-500">ACube USA LLC</h1>
                          <h5>
                            401 Ryland St. STE 200-A,<br></br> Reno, WASHOE
                            COUNTY,<br></br> NV 89502 USA
                          </h5>
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" xl="6">
                      <div className="address-item">
                        <div className="flag-circle">
                          <img src={AusFlag} alt="Aus Flag" loading="lazy" />
                        </div>
                        <div className="address-info">
                          <h1 className="ft-wt-500">Australia</h1>
                          <h5>
                            ACubetech solutions<br></br> Engenesis Level 14,{" "}
                            <br></br>275 Alfred Street North Sydney,<br></br>{" "}
                            New South Wales 2060<br></br> Australia 02 91880844
                          </h5>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs="12" className="mt-4 mt-md-0 mb-4">
                  <Row className="gap-3 gap-lg-0">
                    <Col xs="12" xl="6">
                      <div className="address-item">
                        <div className="flag-circle">
                          <img
                            src={IndianFlag}
                            alt="India Flag"
                            loading="lazy"
                          />
                        </div>
                        <div className="address-info">
                          <h1 className="ft-wt-500">Bangalore</h1>
                          <h5>
                            ACubetech solutions Pvt Ltd<br></br>Brigade IRV, 3rd
                            Floor.<br></br>Nellurhalli, Whitefield,<br></br>
                            Bangalore - 560066, India.
                          </h5>
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" xl="6">
                      <div className="address-item">
                        <div className="flag-circle">
                          <img
                            src={IndianFlag}
                            alt="India Flag"
                            loading="lazy"
                          />
                        </div>
                        <div className="address-info">
                          <h1 className="ft-wt-500">Chennai</h1>
                          <h5>
                            ACubetech solutions Pvt Ltd<br></br>Akshaya CUBE,
                            6th Floor.<br></br>OMR Thoraipakkam, Near BSR Mall,
                            <br></br>Chennai - 600096, India.
                          </h5>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs="12" md="6" xl="5">
              <ContactFormCard />
            </Col>
            <Col xs="12" className="mt-3">
              <Row className="gap-3 gap-lg-0">
                <Col xs="12">
                  <p className="mb-3 mb-lg-4 ft-wt-600">On-Call Support</p>
                </Col>
                <Col xs="12">
                  <Row className="gap-4 gap-md-0">
                    <Col xs="12" md="4">
                      <div className="d-flex align-items-center gap-3 h-100">
                        <div className="flag-circle">
                          <img src={USAFlag} alt="USA Flag" loading="lazy" />
                        </div>
                        <div className="address-info">
                          <a href="tel:+17026054713" className="text-primary">
                            <h4>+1 (702) 605-4713</h4>
                          </a>
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" md="4">
                      <div className="d-flex align-items-center gap-3">
                        <div className="flag-circle">
                          <img
                            src={IndianFlag}
                            alt="India Flag"
                            loading="lazy"
                          />
                        </div>
                        <div className="address-info w-100">
                          <div className="d-flex align-items-center gap-3 mb-2 flex-wrap">
                            <p className="text-primary ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>Sales Team:</p>
                            <a href="tel:+917899150871" className="text-primary mb-0"><h4 className="mb-0">+91 7899 150 871</h4></a>
                          </div>
                          <div className="d-flex align-items-center gap-3 mb-0 flex-wrap">
                            <p className="text-primary ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>HR Team:</p>
                            <a href="tel:+919686077111" className="text-primary"><h4 className="mb-0">+91 9686 077 111</h4></a>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <AcubeIntroVideo />
        <Container>
          <Row>
            <Col xs="12" lg="6">
              <TestimonialVideoPlayer />
            </Col>
            <Col xs="12" lg="6">
              <SentryVideoTestimonial />
            </Col>
          </Row>
        </Container>
        <BrandsCarousel />
        <TestimonialCarousel />
        <ContactForm />
      </section>
    </>
  );
};

export default ContactUs;
